<template>
    <div class="login">
        <img
            class="login_bg"
            src="static/img/logo-bg3.jpg" />
        <div class="login_box">
            <header class="login_header">
                <img
                    class="login_logo"
                    src="static/img/logo1.png" />
                <span>充一点电运营管理平台</span>
            </header>
            <el-form
                label-width="66px"
                :model="dataForm"
                ref="dataForm"
                @keyup.enter.native="loginSubmit">
                <el-form-item
                    label="手机号"
                    prop="username">
                    <el-input
                        size="small"
                        placeholder="请输入手机号"
                        suffix-icon="el-icon-phone"
                        v-model="dataForm.username">
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="密码"
                    prop="password">
                    <el-input
                        size="small"
                        type="password"
                        placeholder="请输入密码"
                        suffix-icon="el-icon-goods"
                        v-model="dataForm.password">
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="验证码"
                    prop="captcha">
                    <el-row :gutter="20">
                        <el-col :span="11">
                            <el-input
                                size="small"
                                placeholder="请输入验证码"
                                v-model="dataForm.captcha">
                            </el-input>
                        </el-col>
                        <el-col
                            :span="12">
                            <img
                                class="login_captcha_path_img"
                                :src="captchaPath"
                                @click="getCaptcha()"/>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item>
                    <el-button
                        size="small"
                        type="info"
                        @click="loginSubmit">
                        <i class="el-icon-sold-out"></i>
                        登录
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="foot">
            <div class="copyright">
                <p
                    class="copyright_icp"
                    @click="openBeian">
                    粤ICP备14042398号
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import login from './login.js';
    export default {
        ...login
    };
</script>

<style src="./login.css" scoped></style>

<style type="text/css">
/*校验*/
.login .el-form-item__error {
    top: 94%;
    padding-top: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/common/login/login.vue